module.exports = __webpack_public_path__ + "static/dx-8449423f09e4fd1eddeed5d96ed6e740.jpg";